module.exports = __webpack_public_path__ + "static/media/ico_ellipse_v_o.26c4a121.svg";